import { PropsWithChildren, createContext, memo, useContext } from "react";

import { Exception } from "@tsp-core/exception";
import { checkIsNotNullish } from "@tsp-core/utils/nullish";

import { FormMetadata } from "../types";

const FormMetadataContext = createContext<FormMetadata | undefined>(undefined);

export type FormMetadataContextProviderProps<Metadata extends FormMetadata> = PropsWithChildren<{ metadata: Metadata }>;

function FormMetadataContextProvider<Metadata extends FormMetadata>(props: FormMetadataContextProviderProps<Metadata>) {
  const { children, metadata } = props;

  return <FormMetadataContext.Provider value={metadata}>{children}</FormMetadataContext.Provider>;
}

const Wrapper = memo(FormMetadataContextProvider) as typeof FormMetadataContextProvider;

export { Wrapper as FormMetadataContextProvider };

export function useFormMetadata<Metadata extends FormMetadata>(): Metadata {
  const context = useContext(FormMetadataContext);
  if (!checkIsNotNullish(context)) {
    throw new Exception(
      -1,
      "FormMetadataContext is nullish! Please check that you are using useFormMetaContext in a child of FormMetadataContextProvider!",
      null,
    );
  }

  return context as Metadata;
}
